<app-modal-component [open]="openModal" label="Edit campaign details">
  <div class="cf-shell">
    <app-form-wrapper [title]="title" (iconClick)="onClose.emit()" icon="close">
      <form class="cf" [formGroup]="campaignDetailsForm" (ngSubmit)="handleSubmit()" novalidate>
        <div class="cf__grid">
          <!-- campaign name -->
          <input-field
            class="cf__wide"
            label="Campaign name"
            [errorMessage]="submitted && name?.invalid ? 'Enter a campaign name.' : ''"
          >
            <input
              class="input-style"
              placeholder="For example, October loyalty offer"
              formControlName="name"
            />
          </input-field>

          <!-- campaign description -->
          <input-field
            class="cf__wide"
            label="Description"
            [errorMessage]="submitted && description?.invalid ? 'Describe the campaign in a sentence or two.' : ''"
          >
            <textarea
              name="description"
              id="description"
              rows="3"
              class="input-style"
              placeholder="What the campaign is for and who it reaches"
              formControlName="description"
            ></textarea>
          </input-field>

          <!-- Start date -->
          <input-field
            label="Start date"
            hint="Set when the campaign was created."
            [errorMessage]="submitted && startDate?.invalid ? 'This campaign has no start date, so it cannot be saved here. Contact support to set one.' : ''"
          >
            <input readonly type="date" class="input-style" formControlName="startDate" />
          </input-field>

          <!-- End date -->
          <input-field
            label="End date"
            [errorMessage]="
              endDate?.errors?.['minDate']
                ? 'Choose ' + minEndLabel + ' or later. The end date can move later, not earlier.'
                : submitted && endDate?.errors?.['required']
                ? 'Choose an end date.'
                : ''
            "
          >
            <input
              type="date"
              class="input-style"
              formControlName="endDate"
              [min]="minEndDate"
              (change)="validateEndDate()"
            />
          </input-field>
        </div>

        <!-- buttons -->
        <div class="cf__foot">
          <customizable-button title="Cancel" [outline]="true" (click)="onClose.emit()" type="button" />
          <customizable-button title="Save details" type="submit" [loading]="campaignsService.isLoading" />
        </div>
      </form>
    </app-form-wrapper>
  </div>
</app-modal-component>
